import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectExpensesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectExpensesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectExpensesRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getProjectExpenses() {
      return getState().projectExpenses;
    },
  };
}

export { createSelector };
